/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import { AxiosUtil } from 'src/utils';
import LoginDTO from "src/models/generated/LoginDTO";
import LoginResultDTO from "src/models/generated/LoginResultDTO";
import LoginTwoFactorDTO from "src/models/generated/LoginTwoFactorDTO";
import PasswordResetRequestDTO from "src/models/generated/PasswordResetRequestDTO";
import PasswordResetResponseDTO from "src/models/generated/PasswordResetResponseDTO";
import PasswordUpdateDTO from "src/models/generated/PasswordUpdateDTO";
import RegisterDTO from "src/models/generated/RegisterDTO";

export class AuthorizationController {
    /**
     * get: /api/Authorization
     */
    public get() {
        const route = `api/Authorization`;
        return AxiosUtil.get<LoginResultDTO>(route, LoginResultDTO.create);
    }

    /**
     * post: /api/Authorization/login
     */
    public login(model: LoginDTO) {
        const route = `api/Authorization/login`;
        return AxiosUtil.post<LoginResultDTO, LoginDTO>(route, model, LoginResultDTO.create);
    }

    /**
     * post: /api/Authorization/two_factor
     */
    public twoFactor(model: LoginTwoFactorDTO) {
        const route = `api/Authorization/two_factor`;
        return AxiosUtil.post<LoginResultDTO, LoginTwoFactorDTO>(route, model, LoginResultDTO.create);
    }

    /**
     * post: /api/Authorization/passwordReset
     */
    public passwordResetRequest(model: PasswordResetRequestDTO) {
        const route = `api/Authorization/passwordReset`;
        return AxiosUtil.post<any, PasswordResetRequestDTO>(route, model);
    }

    /**
     * post: /api/Authorization/passwordReset/response
     */
    public passwordResetResponse(model: PasswordResetResponseDTO) {
        const route = `api/Authorization/passwordReset/response`;
        return AxiosUtil.post<any, PasswordResetResponseDTO>(route, model);
    }

    /**
     * post: /api/Authorization/updatePassword
     */
    public updatePassword(model: PasswordUpdateDTO) {
        const route = `api/Authorization/updatePassword`;
        return AxiosUtil.post<LoginResultDTO, PasswordUpdateDTO>(route, model, LoginResultDTO.create);
    }

    /**
     * post: /api/Authorization/register
     */
    public registerUser(model: RegisterDTO) {
        const route = `api/Authorization/register`;
        return AxiosUtil.post<LoginResultDTO, RegisterDTO>(route, model, LoginResultDTO.create);
    }

    /**
     * post: /api/Authorization/register/interpreter
     */
    public registerInterpreter(model: RegisterDTO) {
        const route = `api/Authorization/register/interpreter`;
        return AxiosUtil.post<LoginResultDTO, RegisterDTO>(route, model, LoginResultDTO.create);
    }
}

export default new AuthorizationController();
